import { withInstall } from '@fx-front-framework/utils/with-install'
import PageDetail from './src/page-detail.vue'

export const FxPageDetail = withInstall(PageDetail)
export default FxPageDetail
